export default {
  currentPrizeId: null,
  fetchingEntries: false,
  selectingWinners: false,
  manualEntryModalOpen: false,
  submittingManualEntry: false,
  breakSearchText: "",
  breakSearchResults: [],
};



// WEBPACK FOOTER //
// ./public/pages/ListEntries/initialState.js